import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AppConfiguration } from '../config/app-configuration';
import { environment } from 'src/environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    private pendingHTTPRequests$ = new Subject<void>();

    constructor(private router: Router, private appConfig: AppConfiguration) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (localStorage.getItem('token') != null) {
            if (req.url == environment.urlInformation) {
                const clonedReq = req.clone({
                    headers: req.headers.set("Authorization", "Basic " + btoa(environment.polarixapiuser + ":" + environment.polarixapipass),)
                });
                return next.handle(clonedReq).pipe(
                    tap(
                        succ => { },
                        err => {
                            if (err.status === 401) {
                                localStorage.removeItem('token');
                                this.router.navigateByUrl('/user/login');
                            }
                        }
                    )
                );

            } else {
                const clonedReq = req.clone({
                    headers: req.headers.set('Authorization', 'Bearer ' + localStorage.getItem('token'))
                });
                return next.handle(clonedReq).pipe(
                    takeUntil(this.pendingHTTPRequests$.asObservable()),
                    tap(
                        succ => { },
                        err => {
                            if (err.status === 401) {
                                localStorage.removeItem('token');
                                this.router.navigateByUrl('/user/login');
                            }
                        }
                    )
                );
            }
        } else {
            return next.handle(req.clone());
        }
    }
}
